<template>
    <div class="psychology backgroundImage">
        <a-row type="flex" :gutter="[0, 20]" justify="space-between" style="padding: 0 26px;">
            <a-col :xs="11" :sm="11" :md="11" :lg="5" :xl="5">
                <div class="operateBox" style="background-color: #68AECB;" @click="toPage('Questionnaire')">
                    <span>问卷调查</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
                </div>
            </a-col>
            <a-col :xs="11" :sm="11" :md="11" :lg="5" :xl="5">
                <div class="operateBox" style="background-color: #60D1D3;" @click="goStudyFn(dataSourceOne)">
                    <span>学习资料</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
                </div>
            </a-col>
            <a-col :xs="11" :sm="11" :md="11" :lg="5" :xl="5">
                <div class="operateBox" style="background-color: #92E8DB;" @click="toPage('/course/consult')">
                    <span>咨询预约</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
                </div>
            </a-col>
            <a-col :xs="11" :sm="11" :md="11" :lg="5" :xl="5">
                <div class="operateBox" style="background-color: #515F91;">
                    <span>我的档案</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
                </div>
            </a-col>
        </a-row>
        <!-- <a-row type="flex" justify="end" align="bottom" style="margin-top: 50px;">
            <a-col :xs="24" :sm="11" :md="11" :lg="8" :xl="8">
                <img src="../../assets/image/XLJK_FOOTER.png" style="width: 100%;" alt="">
            </a-col>
        </a-row> -->
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
    name: 'psychology',
    components: {},
    data() {
        return {
            dataSourceOne:{}
        }
    },
    created() { this.init()},
    mounted() { document.title=this.$route.query.name },
    methods: {
        init() {
            getAction('/teaching/teachingCourse/studentCourseNew', { courseType: 9, pageSize: 1 }).then(res => {
                if (res.success && res.result.records) {
                    this.dataSourceOne = res.result.records[0]
                    console
                }
                if (res.code === 510) {
                    this.$message.warning(res.message)
                }
                this.loading = false
            })
        },
        toPage(url) {
            this.$router.push({ path: url })
        },
        goStudyFn(row){
            this.$router.push({ path: '/course/chapter', query: { name: row.courseName, id: row.id } })
        }
    }
}
</script>
<style lang='scss' scoped>
.psychology {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    min-height:calc(100vh - 50px);
    padding-top: 64px;
    background-image: url('../../assets/image/XLJK_FOOTER.png');
    
    .operateBox {
        width: 100%;
        height: 118px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        border-radius: 14px;
        font-size: 24px;
        flex-direction: column;
        cursor: pointer;
    }
}
</style>

